import { render, staticRenderFns } from "./AccountConnections.vue?vue&type=template&id=3645a20e"
import script from "./AccountConnections.vue?vue&type=script&lang=ts"
export * from "./AccountConnections.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports